import {NgModule} from "@angular/core";
import {NStickyBlockDirective} from "./directives/nStickyBlock.directive";

@NgModule({
  declarations: [
    NStickyBlockDirective
  ], // directives, components, and pipes owned by this NgModule
  imports: [],
  exports: [
    NStickyBlockDirective
  ],
  providers: [],
  entryComponents: []
})

export class NStickyModule {

}
